// src/pages/SystemHealth.js
import { useEffect, useState } from 'react';
import API from '../api/axios';
import './SystemHealth.css';

const SystemHealth = () => {
  const [health, setHealth] = useState(null);

  useEffect(() => {
    API.get('/system/health')
      .then(res => setHealth(res.data))
      .catch(console.error);
  }, []);

  if (!health) return <div className="loading">Yükleniyor...</div>;

  const services = [
    { label: 'Backend', status: health.backend === 'ok' },
    { label: 'Database', status: health.database === 'ok' },
    { label: 'Telegram Bot', status: health.telegram_bot !== 'unknown' },
    { label: 'Payment Provider', status: health.payment_provider ? true : false },
    { label: 'Scheduler', status: health.scheduler === 'active' },
  ];

  return (
    <div className="system-page">
      <h1>🖥️ System Health</h1>
      <div className="services-grid">
        {services.map(s => (
          <div key={s.label} className={`service-card ${s.status ? 'up' : 'down'}`}>
            <span className="service-dot" />
            <span className="service-name">{s.label}</span>
            <span className="service-state">{s.status ? 'Operational' : 'Down'}</span>
          </div>
        ))}
      </div>
      <div className="info-cards">
        <div className="info-card">
          <span className="info-label">Son Bot Aktivitesi</span>
          <span className="info-value">{health.last_bot_activity ? new Date(health.last_bot_activity).toLocaleString('tr-TR') : 'Yok'}</span>
        </div>
        <div className="info-card">
          <span className="info-label">Son Ödeme</span>
          <span className="info-value">{health.last_payment ? new Date(health.last_payment).toLocaleString('tr-TR') : 'Yok'}</span>
        </div>
      </div>
      <p className="timestamp">Son kontrol: {new Date(health.timestamp).toLocaleString('tr-TR')}</p>
    </div>
  );
};

export default SystemHealth;